// extracted by mini-css-extract-plugin
export default {"chatContainer":"chatContainer---mM0af","messagesContainer":"messagesContainer---WrDIa","inputContainer":"inputContainer---Pk4cs"};